'use strict';

export default class DevisBlock {
  constructor(options) {
    console.log('DevisBlock module');

    const defaults = {
        form: '.devisBlock__form',
        formNextBtn: '#next_part-button',
        formSubmitBtn: '#edit-submit'
    };

    this.options = Object.assign({}, defaults, options);
    this.stepWidth = $(this.options.form).find('fieldset').outerWidth();


    //auto start
    this._nextBtnAction();
    this._messagesDevisBlock();

  }

  _nextBtnAction () {
      $(this.options.formNextBtn).on('click', function (evt) {
         if(($('.form-checkbox:checked').length > 0)){
          $(this.options.form).find('fieldset').css('display', 'inline-block');
          $(this.options.form).find(' > div').animate({ scrollLeft: this.stepWidth }, 300);
          $("#messages_demande_checkbox_error_cb").css("display","none");
        }
        else{
            $("#messages_demande_checkbox_error_cb").css("display","block");                      
        }
      }.bind(this));
  }

  _messagesDevisBlock () {

    if($(".devisBlock__form").html()){
     $(".page__messages").css("display","none");
    }

    if( document.getElementById('messages')){
      var msg = document.getElementById('messages').innerHTML;
      if( document.getElementById('messages_demande')){        
        document.getElementById('messages_demande').innerHTML = msg;
        $(this.options.form).find('fieldset').css('display', 'inline-block');
        $(this.options.form).find(' > div').animate({ scrollLeft: this.stepWidth }, 300);
        $(".devisBlock__form .page__messages").css("display","block");
        $("html").animate( { scrollTop : $(".devisBlock__form").offset().top - $(".devisBlock__form").height() }, 300 );
      }
    }

    $('.form-checkbox').change(function() {
        if($(this).is(":checked") && $(this).val() == "Autre") {
            $('.form-checkbox').not(this).attr("checked", false).change();
            $("#messages_demande_checkbox_error_cb").css("display","none");
        }
        else if($(this).is(":checked") && $(this).val() != "Autre" ){
            $("#edit-field-service-request-autre").attr("checked", false).change();
            $("#messages_demande_checkbox_error_cb").css("display","none");
        }
    });

    

  }


}
